import React from 'react';
import FilterSection from '@client/components/search/FilterSection';
import {
  ALL_FILTER_CONFIGS,
  DOCUMENT_TYPE,
  ENVIRONMENT_FILTER_CONFIGS,
} from '@client/feature/product/config/filterConfigs';

const Environment = ({ filters, onFilterChange, filterLabels }) => {
  return (
    <FilterSection
      filterConfigs={ENVIRONMENT_FILTER_CONFIGS}
      allFilterConfigs={ALL_FILTER_CONFIGS}
      filters={filters}
      onFilterChange={onFilterChange}
      document={DOCUMENT_TYPE}
      className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
      filterLabels={filterLabels}
    />
  );
};

export default Environment;
